import React from "react";
import "./LoadingComponent.css";

export const LoadingComponent = ({ type = 0 }) => {
  const typeToString = (type) => {
    if (type === 1) return "LoadActorDataComponent (actor null)";
    else if (type === 2) return "CallbackSuccessComponent";
    else if (type === 3) return "PersistGate";
    return "Default LoadingComponent";
  };
  console.log("Show loading component, type", typeToString(type));
  return (
    <div className="loader-root">
      <div className="loader-bg" />
      <div className="loader-overlay" />
      <div className="loader-content">
        <div className="loader-spinner" />
        <div className="loader-text">Please wait a moment…</div>
      </div>
    </div>
  );
};
